<template>


  <div class="container put-right" style="direction:rtl">
  

      <h3 class="heading" style="display:initial;margin-left:2rem"> الحي</h3>
        <form style="display:initial;">
 <router-link to="/Adddistrict"> <button type="button" class="btn btn-primary">اضافة</button> </router-link>
      </form>


<div class="container menu">
<div class="table-responsive">
<table class="table">
  <thead>
    <tr>
      <th scope="col"> الترتيب</th>
      <th scope="col">  اسم المدينة  </th>
      <th scope="col"> اسم الحي</th>
     
    </tr>
  </thead>
  <tbody>
    
    <tr v-for="keey in formdata2" :key="keey.id" >
      
      <th scope="row" >{{keey.id}}</th>
      <td>{{keey.city_ar_name}}</td>
    
      <td>       {{keey.name_ar}} </td>
     
    
    </tr>
   
  </tbody>
</table>
</div>
  
</div>
</div>


           


   

</template>

<script>
import  geturl  from "@/comp/geturl";

export default {
name:'districtView',
data(){
  return{
     formdata2:[],    
  }
},
mounted() {
  
 
      
    
       fetch(geturl()+"district/", {
      
      headers: {"Content-Type": "application/json"},
      })
      .then(res => res.json())
      .then(data => {this.formdata2 = data
      })
    }
}
</script>

<style>

</style>